import { defineStore } from 'pinia'
import { api } from '../api/api.js';

export const useUserStore = defineStore({
  id: 'user-store',
  state: () => ({
    currentUser: null,
  }),
  actions: {
    async getCurrentUser() {
      const { data } = await api.auth.getCurrentUser()

      this.currentUser = data
    }
  }
})
